"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorSort = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const SensorSort = () => {
    const flagsHook = (0, hooks_1.useFlags)();
    const { options, config } = (0, hooks_1.useReactifySearchContext)();
    const { curation } = (0, hooks_1.useCuration)();
    const { sortOption } = (0, hooks_1.useSortBy)();
    const { sort, query } = react_1.default.useMemo(() => {
        return {
            sort: buildSort({
                mode: options.mode,
                curation,
                sortOption,
                collectionHandle: options.mode === "collection" ? options.collectionHandle : undefined,
            }),
            query: buildQuery({
                sortOption,
                curation,
            }),
        };
    }, [options, config, sortOption, curation]);
    if (!flagsHook.flags["reactify-search:flag_sensor_sort"]) {
        return null;
    }
    return (react_1.default.createElement(ReactiveComponent_1.default, { componentId: "SensorSort", customQuery: () => ({
            sort,
            query,
        }) }));
};
exports.SensorSort = SensorSort;
const buildSort = (args) => {
    var _a;
    const { mode, curation, sortOption, collectionHandle } = args;
    // curation positions are only applied for the default `collections.position` or `_score` sort
    // if the sort is something else, apply a normal sort which applies what the user has requested
    if (mode !== "instant-search") {
        if (sortOption &&
            !["_score", "collections.position"].includes(sortOption.field)) {
            return [{ [sortOption.field]: sortOption.direction }];
        }
    }
    const sorts = [];
    // collection curation pin sorting
    if (mode === "collection" && collectionHandle) {
        if (curation === null || curation === void 0 ? void 0 : curation.collectionHandle) {
            sorts.push({
                "curations.position": {
                    unmapped_type: "long",
                    order: "asc",
                    nested: {
                        path: "curations",
                        filter: {
                            term: {
                                [`curations.collectionHandle.keyword`]: curation.collectionHandle,
                            },
                        },
                    },
                },
            });
        }
    }
    // search curation pin sorting
    if (mode === "search" || mode === "instant-search") {
        if (curation === null || curation === void 0 ? void 0 : curation.searchTerm) {
            sorts.push({
                "curations.position": {
                    unmapped_type: "long",
                    order: "asc",
                    nested: {
                        path: "curations",
                        filter: {
                            term: {
                                [`curations.searchTerm.keyword`]: (_a = curation.searchTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                            },
                        },
                    },
                },
            });
        }
    }
    // curation boost sorting
    if (curation) {
        if (0 < curation.boosting.groupings.length) {
            const groupings = curation.boosting.groupings.sort((a, b) => a.position > b.position ? 1 : -1);
            for (const grouping of groupings) {
                try {
                    const query = JSON.parse(grouping.query);
                    if (query)
                        sorts.push(query);
                }
                catch (_b) {
                    console.error(`query could not be parsed for boost grouping`, grouping);
                }
            }
        }
        if (0 < curation.boosting.sortings.length) {
            const sortings = curation.boosting.sortings.sort((a, b) => a.position > b.position ? 1 : -1);
            for (const sorting of sortings) {
                try {
                    const query = JSON.parse(sorting.query);
                    if (query)
                        sorts.push(query);
                }
                catch (_c) {
                    console.error(`query could not be parsed for boost sorting`, sorting);
                }
            }
        }
    }
    // default collection sorting
    if (mode === "collection" && collectionHandle) {
        sorts.push(...mapCollectionPositionSortClause(collectionHandle));
    }
    // default search sorting
    if (mode === "search" || mode === "instant-search") {
        sorts.push("_score");
    }
    return sorts;
};
/**
 * Return a sort clause which sorts by position within the given collection.
 */
function mapCollectionPositionSortClause(collectionHandle) {
    return [
        {
            "collections.position": {
                order: "asc",
                nested: {
                    path: "collections",
                    filter: {
                        term: {
                            "collections.handle.keyword": collectionHandle,
                        },
                    },
                },
            },
        },
    ];
}
const buildQuery = (args) => {
    var _a;
    const { curation, sortOption } = args;
    if (!curation ||
        ["global_collection", "global_search"].includes(curation.id)) {
        return undefined;
    }
    return {
        bool: {
            must_not: [
                {
                    nested: {
                        path: "curations",
                        query: {
                            bool: {
                                must: [
                                    {
                                        term: {
                                            [`curations.${"collection" === curation.type
                                                ? "collectionHandle"
                                                : "searchTerm"}.keyword`]: "collection" === curation.type
                                                ? curation.collectionHandle
                                                : (_a = curation.searchTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                                        },
                                    },
                                    {
                                        term: {
                                            "curations.hidden": true,
                                        },
                                    },
                                ],
                            },
                        },
                    },
                },
                // hide callout when not sorting by _score or collections.position
                ...(sortOption &&
                    !["_score", "collections.position"].includes(sortOption.field)
                    ? [
                        {
                            term: {
                                type: "callout",
                            },
                        },
                    ]
                    : []),
            ],
        },
    };
};
//# sourceMappingURL=SensorSort.js.map